var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.661,
    height: 67.853,
    viewBox: "0 0 76.661 67.853",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1546",
    "data-name": "Group 1546",
    transform: "translate(-2003.985 -1075.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M94.189,86.783H35.182a4.081,4.081,0,0,1-4.077-4.077V39.573a1.689,1.689,0,0,1,3.378,0V82.706a.708.708,0,0,0,.7.7H94.189a.708.708,0,0,0,.7-.7V46.521a.708.708,0,0,0-.7-.7h-29.5a1.689,1.689,0,1,1,0-3.378h29.5a4.082,4.082,0,0,1,4.077,4.075V82.706a4.081,4.081,0,0,1-4.077,4.077",
    transform: "translate(1981.38 1049.623)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M87.826,46.564H37.354a6.249,6.249,0,0,1,0-12.5H63.331a1.689,1.689,0,0,1,0,3.378H37.354a2.871,2.871,0,1,0,0,5.742H87.826a2.871,2.871,0,0,0,0-5.742H78.658a1.689,1.689,0,1,1,0-3.378h9.168a6.249,6.249,0,0,1,0,12.5",
    transform: "translate(1981.38 1048.883)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M87.514,66.914h-6.47a6.249,6.249,0,0,1,0-12.5h6.47a1.689,1.689,0,0,1,0,3.378h-6.47a2.871,2.871,0,0,0,0,5.742h6.47a1.689,1.689,0,0,1,0,3.378",
    transform: "translate(1989.845 1052.826)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M42.1,47.592a1.689,1.689,0,0,1-.719-3.218L74.687,28.756,82.972,45.14a1.69,1.69,0,1,1-3.015,1.526l-6.8-13.46L42.812,47.432a1.685,1.685,0,0,1-.716.16",
    transform: "translate(1983.182 1047.854)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M93.253,91.451l-11.2-19.4a5.286,5.286,0,0,0-9.157,0l-11.2,19.4a5.287,5.287,0,0,0,4.578,7.93h22.4a5.287,5.287,0,0,0,4.578-7.93",
    transform: "translate(1943 1044.083)",
    fill: "#ee7ae6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M75.074,86.228a1.69,1.69,0,0,1-1.689-1.689V78.594a1.689,1.689,0,1,1,3.378,0v5.945a1.69,1.69,0,0,1-1.689,1.689",
    transform: "translate(1945.403 1045.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M75.074,90.575a1.69,1.69,0,0,1-1.689-1.689v-.381a1.689,1.689,0,1,1,3.378,0v.381a1.69,1.69,0,0,1-1.689,1.689",
    transform: "translate(1945.403 1047.455)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherWallet);
export default __webpack_public_path__ + "static/media/other_wallet.dd3621fb3f212aac13907e24ba1d9e3e.svg";
export { ForwardRef as ReactComponent };